<template lang="html">
  <boxwrap class="level--inner">
    <boxwrap-contents>
      <tbl
        :scrollable="true"
      >
        <tbl-inner >
          <tbl-head>
            <tbl-row>
              <tbl-td
                name="level"
              >
                Level
              </tbl-td>
              <tbl-td
                name="icon"
              >
                icon (Image source)
              </tbl-td>
            </tbl-row>
          </tbl-head>
          <tbl-body>
            <tbl-row
              v-for="(level, i) in levels"
              :key="i"
            >
              <tbl-td
                name="level"
              >
                {{ level.level }}
              </tbl-td>
              <tbl-td
                name="icon"
              >
                <i :class="`ico--level -${i}`"></i>
                <span class="level-source-text">{{ level.icon }}</span>
                <label for="icon-upload" class="level-icon-fileupload">
                  <button class="btn--default -withlabel">
                    <i class="ico--upload"></i>
                    <span>choode file</span>
                  </button>
                  <input
                    type="file"
                    id="icon-upload"
                    class="level-icon-file"
                  />
                </label>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>
      </tbl>
    </boxwrap-contents>
  </boxwrap>
</template>

<script>
export default {
  name: 'level',

  components: {
  },

  data () {
    return {
      levels: [
        {
          level: 'Level 1',
          icon: 'source'
        },
        {
          level: 'Level 2',
          icon: 'source'
        },
        {
          level: 'Level 3',
          icon: 'source'
        },
        {
          level: 'Level 4',
          icon: 'source'
        },
        {
          level: 'Level 5',
          icon: 'source'
        },
        {
          level: 'Level 6',
          icon: 'source'
        },
        {
          level: 'Level 7',
          icon: 'source'
        },
        {
          level: 'VIP',
          icon: 'source'
        },
        {
          level: 'VVIP',
          icon: 'source'
        },
        {
          level: 'Admin',
          icon: 'source'
        }
      ]
    }
  },

  computed: {

  },

  watch: {

  },

  methods: {
  }
}
</script>

<style lang="css" scoped>
</style>
